/**
 * Item costing / WAC API calls.
 * TODO: All endpoints are pending backend implementation.
 */
import client from './inventory-request';

// API: GET /inventory/items/{itemId}/cost-history/
export const getItemCostHistory = (itemId) =>
  client.get(`/inventory/items/${itemId}/cost-history/`);
